import React from 'react';
import AdvancedSubMenu from '../AdvancedSubMenu';
import BasicSubMenu from '../BasicSubMenu';
import ImageSubMenu from '../ImageSubMenu';
import ArrowSubMenu from '../ArrowSubMenu';
import TextSubMenu from '../TextSubMenu';
import { MENU_TYPE } from '../types';
const MENU_COLLECTION = {
    [MENU_TYPE.Advanced]: AdvancedSubMenu,
    [MENU_TYPE.Basic]: BasicSubMenu,
    [MENU_TYPE.Text]: TextSubMenu,
    [MENU_TYPE.Image]: ImageSubMenu,
    [MENU_TYPE.Arrow]: ArrowSubMenu,
};
export const getSubMenu = (type, item) => {
    if (!MENU_COLLECTION[type]) {
        return null;
    }
    const MenuComponent = MENU_COLLECTION[type];
    return React.createElement(MenuComponent, { item: item });
};
//# sourceMappingURL=menuStatus.js.map